import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get, includes } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../../Common/CloseIcon";
import ProfileSurvey from "./ProfileSurvey";

import { getLov } from "../../../utils/lov";
import { getAttributeName } from "../../../utils/profile";
import { getVerificationStatus } from "../../../utils/eventGroups";
import { LANGUAGES } from "../../../constants/common";
import {
  VERIFICATION_OK,
  VERIFICATION_WARNING,
  VERIFICATION_THREAT,
} from "../../../constants/eventGroups";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = (theme) => ({
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
  dialogPaper: {
    [theme.breakpoints.down("sm")]: {},
    [theme.breakpoints.up("sm")]: {
      minWidth: "900px",
      maxHeight: "calc(100vh - 60px)",
    },
  },
  dialogPaperShort: {
    [theme.breakpoints.down("sm")]: {
      margin: "0px !important",
      maxHeight: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      minWidth: "400px",
      maxHeight: "calc(100vh - 60px)",
    },
  },
  dialogOnlyOneSurvey: {
    minWidth: "574px",
    maxHeight: "calc(100vh - 60px)",
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

const ProfileSurveyDialog = (props) => {
  const {
    classes,
    title,
    surveys,
    profileId,
    language,
    profileName,
    onlyOneSurvey,
    hide = { leftCol: false, new: false },
  } = props;
  const [open, setOpen] = React.useState(
    get(props, ["onlyEdit", "open"]) || get(props, ["forceOpen"]) || false
  );
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    const fetchLov = async () => {
      setLov({
        eventTypes: await getLov("eventTypes"),
      });
    };
    fetchLov();
  }, []);

  const onlyEditOpen = get(props, ["onlyEdit", "open"]);
  React.useEffect(() => {
    if (onlyEditOpen !== undefined && typeof onlyEditOpen === "boolean") {
      setOpen(onlyEditOpen);
    }
  }, [onlyEditOpen]);

  const survey =
    get(surveys, ["lastSurvey"]) || get(surveys, ["referenceSurvey"]);

  const closeFunction = () => {
    if (get(props, ["onlyEdit", "refreshHistory"])) {
      props.onlyEdit.refreshHistory();
    }
    if (get(props, ["onlyEdit", "onClose"])) {
      props.onlyEdit.onClose();
    }
    setOpen(false);
  };

  return (
    <>
      {!includes([true, false], get(props, ["onlyEdit", "open"])) && (
        <Grid container wrap="nowrap" alignItems="center">
          {get(survey, ["type", "id"]) === 81 && (
            <Grid item className="flexCenter">
              <img
                src={
                  getVerificationStatus(survey) === VERIFICATION_THREAT
                    ? images.verificationIconWarning
                    : getVerificationStatus(survey) === VERIFICATION_WARNING
                    ? images.warningTriangleOrange
                    : getVerificationStatus(survey) === VERIFICATION_OK
                    ? images.verificationIconOk
                    : ""
                }
                alt="status"
                style={{ display: "inline-block", marginRight: "5px" }}
                height="17px"
              />
            </Grid>
          )}
          <Grid item>
            <span
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
              className={classes.link}
            >
              {get(survey, ["verification", `description_${language}`]) ||
                title}
            </span>
          </Grid>
        </Grid>
      )}
      <Dialog
        onClick={(e) => e.stopPropagation()}
        open={open}
        classes={{
          paper: onlyOneSurvey
            ? classes.dialogOnlyOneSurvey
            : hide.leftCol
            ? classes.dialogPaperShort
            : classes.dialogPaper,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid
                item
                xs
                className="text-87 bold-500 text-center flexCenter"
                style={{ justifyContent: "center" }}
              >
                {profileName && (
                  <>
                    <img
                      src={images.humanIconBlack}
                      alt="human_icon"
                      style={{ margin: "-3px 5px 0px" }}
                    />
                    <span>{profileName}</span>
                  </>
                )}
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={closeFunction} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className="text-center text-87">
            {title ||
              getAttributeName(
                { attributes: get(lov, ["eventTypes"]) },
                81,
                language
              )}
          </Grid>
          <Grid item>
            <ProfileSurvey
              surveys={surveys}
              profileId={profileId}
              profileName={profileName}
              language={language}
              contentMaxHeight="none"
              dialog={true}
              hide={hide}
              onlyOneSurvey={onlyOneSurvey}
              onlyEdit={props.onlyEdit}
            />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

ProfileSurveyDialog.propTypes = {
  title: PropTypes.string,
  surveys: PropTypes.object,
  profileId: PropTypes.string,
  language: PropTypes.oneOf(LANGUAGES),
};

export default withStyles(styles)(ProfileSurveyDialog);
